import { gql } from '@apollo/client'

export const GET_PRICING_ERRORS_FOR_STORE = gql`
  query GetPricingErrorsForStore($input: PricingErrorInput!) {
    pricingErrorsForStore(input: $input) {
      results {
        id
        storeId
        productPricingId
        displayAuditId
        upc
        productName
        observedPrice
        expectedPrice
        observedUnitPrice
        expectedUnitPrice
        errorType
        imageUrls
        createdAt
      }
      count
      hasMore
    }
  }
`
